<template>
  <el-dialog
    :title="$t('chooseMenuGroup.selectMenuGroup')"
    :visible.sync="dialogVisible"
    width="80%"
    @close="handleClose">
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <el-row :gutter="20" class="mb-20">
            <el-col :span="18"></el-col>
            <el-col :span="6">
              <el-input-group>
                <el-input
                  v-model="chooseMenuGroupInfo._currentMenuGroupName"
                  :placeholder="$t('chooseMenuGroup.inputMenuGroupName')"
                  size="small"></el-input>
                <el-button
                  slot="append"
                  type="primary"
                  size="small"
                  @click="queryMenuGroups()">
                  {{ $t('chooseMenuGroup.query') }}
                </el-button>
              </el-input-group>
            </el-col>
          </el-row>

          <el-table
            :data="chooseMenuGroupInfo.menuGroups"
            border
            style="width:100%">
            <el-table-column
              prop="gId"
              :label="$t('chooseMenuGroup.groupId')"
              align="center"></el-table-column>
            <el-table-column
              prop="name"
              :label="$t('chooseMenuGroup.groupName')"
              align="center"></el-table-column>
            <el-table-column
              prop="icon"
              :label="$t('chooseMenuGroup.icon')"
              align="center"></el-table-column>
            <el-table-column
              prop="label"
              :label="$t('chooseMenuGroup.label')"
              align="center"></el-table-column>
            <el-table-column
              :label="$t('chooseMenuGroup.belongMerchant')"
              align="center">
              <template slot-scope="scope">
                {{ _getChooseStoreTypeName(scope.row.storeType) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="seq"
              :label="$t('chooseMenuGroup.sequence')"
              align="center"></el-table-column>
            <el-table-column
              prop="description"
              :label="$t('chooseMenuGroup.description')"
              align="center"></el-table-column>
            <el-table-column
              :label="$t('chooseMenuGroup.operation')"
              align="center">
              <template slot-scope="scope">
                <el-button
                  type="primary"
                  size="mini"
                  @click="_chooseMenuGroup(scope.row)">
                  {{ $t('chooseMenuGroup.select') }}
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <el-pagination
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-size="DEFAULT_ROWS"
            layout="total, prev, pager, next"
            :total="total">
          </el-pagination>
        </el-card>
      </el-col>
    </el-row>
  </el-dialog>
</template>

<script>
import { listMenuGroups } from '@/api/dev/menuManage/menuManageApi'

export default {
  name: 'ChooseMenuGroup',
  data() {
    return {
      dialogVisible: false,
      DEFAULT_PAGE: 1,
      DEFAULT_ROWS: 10,
      currentPage: 1,
      total: 0,
      chooseMenuGroupInfo: {
        menuGroups: [],
        _currentMenuGroupName: ''
      }
    }
  },
  methods: {
    open() {
      this.dialogVisible = true
      this._refreshChooseMenuGroupInfo()
      this._loadAllMenuGroupInfo(this.DEFAULT_PAGE, this.DEFAULT_ROWS, '')
    },
    _loadAllMenuGroupInfo(page, rows, name) {
      const params = {
        page,
        row: rows,
        name
      }
      listMenuGroups(params).then(res => {
        this.chooseMenuGroupInfo.menuGroups = res.data
        this.total = res.records
      }).catch(err => {
        console.error('请求失败:', err)
      })
    },
    _chooseMenuGroup(menuGroup) {
      this.$emit('chooseMenuGroup', menuGroup)
      this.$emit('loadData', {
        menuGroupId: menuGroup.gId
      })
      this.dialogVisible = false
    },
    queryMenuGroups() {
      this._loadAllMenuGroupInfo(this.DEFAULT_PAGE, this.DEFAULT_ROWS, this.chooseMenuGroupInfo._currentMenuGroupName)
    },
    _refreshChooseMenuGroupInfo() {
      this.chooseMenuGroupInfo._currentMenuGroupName = ""
    },
    _getChooseStoreTypeName(storeTypeCd) {
      const types = {
        '800900000001': this.$t('chooseMenuGroup.operationTeam'),
        '800900000002': this.$t('chooseMenuGroup.agent'),
        '800900000004': this.$t('chooseMenuGroup.logistics'),
        '800900000005': this.$t('chooseMenuGroup.merchant'),
        '800900000000': this.$t('chooseMenuGroup.devTeam'),
        '800900000006': this.$t('chooseMenuGroup.runner')
      }
      return types[storeTypeCd] || this.$t('chooseMenuGroup.unknown')
    },
    handleCurrentChange(currentPage) {
      this._loadAllMenuGroupInfo(currentPage, this.DEFAULT_ROWS)
    },
    handleClose() {
      this._refreshChooseMenuGroupInfo()
    }
  }
}
</script>

<style scoped>
.mb-20 {
  margin-bottom: 20px;
}
</style>